import Vue from 'vue'
import '../../plugins/axios'
import '../../plugins/machine'
import App from './App.vue'
import i18n from '@/plugins/i18n'
import Base64 from 'crypto-js/enc-base64'
import CryptoJS from 'crypto-js'
import Logger from '@/plugins/logger'
import '@/plugins/polyfill-object-fromentries'
import useLanguageTree from '@/commons/language'
import useIEHelper from '@/commons/ie-helper'
import loadWhitelabel, { buildWLParam } from '@/commons/whitelabel.js'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
const { URLSearchParamsWrapper } = useIEHelper()
const { t } = useLanguageTree()

Vue.prototype.$tf = t
Vue.use(Logger, { level: 8 })

Vue.config.productionTip = false

let recaptchaKey = '6LcOwVIUAAAAABr2Uw-VI0UY1UnC_I6E1-m2i8kw'
Vue.prototype.$recaptchaKey = recaptchaKey

let urlParams = URLSearchParamsWrapper(window.location.search)
const wl = decodeURIComponent(urlParams.get('wl') || '')
Vue.prototype.$wlDomain = wl

let hl = urlParams.get('hl') || i18n.locale || 'en-US'
let methods = urlParams.get('access_methods')

if (methods) {
  methods = methods.replace(/\./g, '+').replace(/_/g, '/').replace(/-/g, '=')
  methods = JSON.parse(Base64.parse(methods).toString(CryptoJS.enc.Utf8)) || null
  if (methods && methods.length === 1 && methods[0].oauth2_access_method && methods[0].oauth2_access_method.url) {
    window.location.href = methods[0].oauth2_access_method.url
  } else {
    Vue.prototype.$methods = methods
    loadWhitelabel(Vue.prototype.$wlDomain).then(res => {
      const vuetify = res.vuetify
      Vue.prototype.$headerLogo = res.headerLogo
      Vue.prototype.$wlURL = res.whitelabelURL
      Vue.prototype.$serverConfig = res.serverConfig
      Vue.use(vuetify)
      const app = new Vue({
        i18n,
        vuetify,
        render: h => h(App)
      }).$mount('#app')

      if (process.env.NODE_ENV === 'development' && window) {
        window.app = app
        window.Vue = Vue
      }
    })
  }
} else {
  window.axios.post('access-methods' + buildWLParam(wl, '?')).then(response => {
    if (response.data.length === 1 && response.data[0].url) {
      window.location.href = response.data[0].url
    } else {
      Vue.prototype.$methods = response.data
      loadWhitelabel(Vue.prototype.$wlDomain).then(res => {
        const vuetify = res.vuetify
        Vue.prototype.$headerLogo = res.headerLogo
        Vue.prototype.$wlURL = res.whitelabelURL
        Vue.use(vuetify)
        const app = new Vue({
          i18n,
          vuetify,
          render: h => h(App)
        }).$mount('#app')

        if (process.env.NODE_ENV === 'development' && window) {
          window.app = app
          window.Vue = Vue
        }
      })
    }
  }).catch(() => {
    if (window.location.pathname === '/register') {
      window.location.href = '/error?hl=' + hl + '&error_message=accessMethodError' + buildWLParam(wl)
    } else {
      loadWhitelabel(Vue.prototype.$wlDomain).then(res => {
        const vuetify = res.vuetify
        Vue.prototype.$headerLogo = res.headerLogo
        Vue.prototype.$wlURL = res.whitelabelURL
        Vue.use(vuetify)
        const app = new Vue({
          i18n,
          vuetify,
          render: h => h(App)
        }).$mount('#app')

        if (process.env.NODE_ENV === 'development' && window) {
          window.app = app
          window.Vue = Vue
        }
      })
    }
  })
}
